import { useState } from "react";
import ReactModal from "react-modal";

ReactModal.setAppElement("#root");

const AlertDialog = ({ isOpen, onClose, onConfirm }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex justify-center items-center z-[9999]"
      className="bg-white dark:bg-gray-900 p-6 rounded-2xl shadow-2xl w-[90%] max-w-sm mx-auto border border-gray-200 dark:border-gray-800 outline-none transform transition-all"
    >
      <div className="text-center">
        <h2 className="text-xl font-bold dark:text-white text-gray-800">
          Are you sure?
        </h2>
        <p className="text-gray-500 mt-2 dark:text-gray-400">
          This action is permanent and cannot be undone.
        </p>
        <div className="mt-6 flex gap-3">
          <button
            className="flex-1 py-2.5 px-4 font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg transition-colors"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="flex-1 py-2.5 px-4 text-white font-medium bg-red-600 rounded-lg hover:bg-red-700 transition-colors shadow-sm"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

const DeleteButton = ({
  onDelete,
  style,
  className,
  delete_icon,
  is_disabled,
}) => {
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  return (
    <div className="inline-block w-full">
      <button
        className={className || style}
        disabled={is_disabled}
        onClick={() => setIsAlertOpen(true)}
      >
        {delete_icon ? delete_icon : "Delete"}
      </button>

      <AlertDialog
        isOpen={isAlertOpen}
        onClose={() => setIsAlertOpen(false)}
        onConfirm={onDelete}
      />
    </div>
  );
};

export default DeleteButton;
